
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";

interface FormActionsProps {
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting?: boolean;
}

export const FormActions = ({ onSubmit, isSubmitting = false }: FormActionsProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-end space-x-4">
      <Button
        type="button"
        variant="outline"
        onClick={() => navigate(-1)}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        className="text-white"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Spinner className="mr-2 h-4 w-4" />
            Creating...
          </>
        ) : (
          "Create Client"
        )}
      </Button>
    </div>
  );
};
